import styled from 'styled-components';
import { APP_IMG } from 'src/constants';
import { IMAGE_DEFAULT } from 'src/constants/layout';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

function CardFollowing({ type, data, handlerFollow, statusText, eventDataLayer }) {
  // console.log('CardFollowing', data);
  return (
    <CardWrapper
      className='card-following'
      onClick={() => {
        // ! DATALAYER
        sendDataLayerGlobal({
          ...eventDataLayer
        });
        handlerFollow(type, { id: data?.id, nameTh: data?.nameTh, nameEng: data?.nameEng, image: data?.image || null });
      }}
      statusText={statusText || 'ติดตาม'}
    >
      {/* ---------------------------------- Icon Check ---------------------------------- */}
      <div className='check-symbol'>
        <svg className='checkmark' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'>
          <path className='checkmark__check' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8' />
        </svg>
      </div>
      {/*  ---------------------------------- Image --------------------------------- */}
      <div className='image-following'>
        {data.image ? (
          <img src={`${APP_IMG}${data?.image}`} alt={`image-${data?.nameEng}`} width={200} height={150} />
        ) : (
          <img src={`${IMAGE_DEFAULT}`} alt={`image-${data?.nameEng}`} width={200} height={150} />
        )}
      </div>
      {/* ---------------------------------- Text ---------------------------------- */}
      <div className='text-following '>{`${data?.nameTh || ''}`}</div>
      {/* --------------------------------- Button --------------------------------- */}
      <button className='button-following'>{statusText || 'Follow'}</button>
    </CardWrapper>
  );
}

const CardWrapper = styled.div`
  cursor: pointer;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  /* height: 250px; */

  gap: 6px;
  padding: 8px;
  border-radius: 10px;

  border: 1px solid rgba(0, 0, 0, 0.01);
  background: #fff;

  box-shadow: ${prop => (prop.statusText === 'ติดตาม' ? '0px 3px 5px 0px #00000026' : '0px 0px 0px 2px var(--primary-color)')};

  .text-following {
    min-height: 24px;
    font-family: 'Prompt', sans-serif;
    font-weight: 600;
    font-size: 16px;
    /* display: flex;
    justify-content: center; */
    color: #000;
    text-transform: capitalize;

    display: block;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-align: center;
    overflow: hidden;
    -webkit-line-clamp: 1;
  }

  .image-following {
    position: relative;
    overflow: hidden;

    border-radius: 10px;
    max-height: 160px;
    /* clip-path: polygon(0% 0%, 100% 0%, var(--x-y0, 100% 100%), var(--x-y1, 70% 78%), var(--x-y2, 42% 92%), var(--x-y3, 18% 87%), var(--x-y4, -2% 105%)); */
    /* clip-path: polygon(0% 0%, 100% 0%, var(--x-y0, 100% 104%), var(--x-y1, 76% 90%), var(--x-y2, 36% 100%), var(--x-y3, 17% 92%), var(--x-y4, 0% 104%)); */
    clip-path: polygon(0% 0%, 100% 0%, var(--x-y0, 120% 100%), var(--x-y1, 71% 73%), var(--x-y2, 40% 90%), var(--x-y3, 15% 83%), var(--x-y4, 0% 90%));
    img {
      width: 100%;
      height: 160px;

      border-radius: 10px;
      object-fit: cover;
      object-position: center;

      transition: all ease-in 0.2s;
      filter: ${prop => (prop.statusText === 'ติดตาม' ? 'blur(1px)' : 'none')};
      -webkit-filter: ${prop => (prop.statusText === 'ติดตาม' ? 'blur(1px)' : 'none')};
    }
    @media (max-width: 767px) {
      max-height: 100px;
      img {
        height: 100px;
      }
    }
  }

  .check-symbol {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;

    display: ${prop => (prop.statusText === 'ติดตาม' ? 'none' : 'block')};

    width: 30px;
    height: 30px;

    background-color: var(--primary-color);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

    border: 3px solid #fff;
    border-radius: 100%;

    transition: display ease-in-out 0.1s;

    @media (max-width: 767px) {
      right: 5px;
      top: 5px;
      width: 25px;
      height: 25px;
    }
    .checkmark {
      position: absolute;
      top: -2px;
      left: -1px;
      z-index: 1;

      display: block;
      margin: auto;
      width: 20px;
      height: 20px;
      border-radius: 50%;

      stroke-width: 5;
      stroke: #000;
      stroke-miterlimit: 10;
      stroke-dasharray: 100;
      stroke-dashoffset: 100;

      animation: drawAnimate 0.7s linear forwards;
      @keyframes drawAnimate {
        to {
          stroke-dashoffset: 10;
        }
      }
      @media (max-width: 767px) {
        top: 0px;
        left: 0px;
        width: 15px;
        height: 15px;
      }
    }
  }

  .button-following {
    cursor: pointer;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: 'Prompt', sans-serif;
    font-size: 18px;
    font-weight: 600;
    background-blend-mode: overlay, normal;

    color: ${prop => (prop.statusText === 'ติดตาม' ? 'var(--primary-color)' : '#000')};
    background: ${prop => (prop.statusText === 'ติดตาม' ? '#000000' : 'var(--primary-color)')};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(46, 46, 46, 0.3);

    border: 1px solid var(--primary-color);
    border-radius: 50px;

    padding: 5px 0;
    transition: all ease-in-out 0.2s;
    @media (max-width: 767px) {
      font-size: 14px;
      padding: 3px 0;
      /* border-radius: 6px; */
    }
    &:hover {
      color: #000;
      background: var(--primary-color);
    }
  }

  /* &:active {
    transform: scale(0.8);
  } */

  &:hover {
    img {
      transform: scale(1.2);
      filter: none !important;
      -webkit-filter: none !important;
      @media (max-width: 767px) {
        transform: scale(1);
      }
    }
  }
`;

export default CardFollowing;
